import { Component, ViewChild } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { CalculatorWithdrawVesComponent } from './components/calculator-withdraw-ves/calculator-withdraw-ves.component';
import { WithdrawAccountsStepVesComponent } from './components/withdraw-accounts-step-ves/withdraw-accounts-step-ves.component';
import { CuentaBeneficiario } from '../../interfaces/cuenta-beneficiario.interface';
import { AccountRecipientService } from '../../services/account-recipient.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { WalletVesClientService } from '../../services/wallet-ves-client.service';
import Swal from 'sweetalert2';
import { esBeneficiarioBancoVenezolano } from 'src/app/shared/utils/saldo-ves';

@Component({
  selector: 'app-withdraw-balance-ves',
  templateUrl: './withdraw-balance-ves.component.html',
  styleUrls: ['./withdraw-balance-ves.component.sass']
})
export class WithdrawBalanceVesComponent {
  hasAccounts = false;
  currentStep = 1;
  totalSteps = 3;
  isTransitioning = false;
  slideDirection: 'left' | 'right' = 'left';

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private accountRecipientService: AccountRecipientService,
    private spinner: SpinnerService,
    private walletVesService: WalletVesClientService
  ){
    const ref = this.spinner.start();
    this.validateAccounts();
    this.spinner.stop(ref);
  }

  @ViewChild('beneficiarioComponent') withdrawAccountsStepComponent: WithdrawAccountsStepVesComponent | undefined;
  @ViewChild('calculatorComponent') calculatorComponent: CalculatorWithdrawVesComponent | undefined;

  public subscription: Subscription = new Subscription();
  public user: any;
  public saldoActual = 0;
  public montoRetiro: number = 0;
  public accountSelected: CuentaBeneficiario | undefined;
  public userId: number | undefined = 0;

  ngOnInit(): void {
    this.subscription.add(
      this.store.select('auth').subscribe(({ user }: any) => {
        this.user = user;
        this.userId = user?.usuarioId;
        this.obtenerSaldo();
      })
    );
  }

  async validateAccounts(){
    try {
      const user = await new Promise<any>((resolve) => {
        const sub = this.store.select('auth').subscribe(({ user }: any) => {
          if (user?.usuarioId) {
            resolve(user);
            sub.unsubscribe();
          }
        });
      });
      // Solo cuentan beneficiarios de bancos venezolanos: el retiro VES paga en
      // Venezuela (Nest responde 400 con otro pa\u00eds). Un chileno puede tener
      // beneficiarios solo de Colombia/Per\u00fa y ninguno venezolano.
      const accounts = ((await this.accountRecipientService.getByUser(user.usuarioId)) || [])
        .filter((c) => esBeneficiarioBancoVenezolano(c));
      if (accounts.length <= 0) {
        this.hasAccounts = false;
        const r = await Swal.fire({
          confirmButtonColor: '#1e5a3f',
          icon: 'info',
          title: 'Atenci\u00f3n',
          text: 'Para retirar bol\u00edvares necesitas un beneficiario con cuenta en un banco de Venezuela. Agr\u00e9galo en tu libreta de beneficiarios.',
          confirmButtonText: 'Ir a mis beneficiarios',
          showCancelButton: true,
          cancelButtonText: 'Volver al inicio',
        });
        this.router.navigate([r.isConfirmed ? '/wallet/client/recipients' : '/wallet/home']);
      } else {
        this.hasAccounts = true;
      }
    } catch {
      this.hasAccounts = false;
    }
  }

  obtenerSaldo(){
    if (this.user?.usuarioId) {
      this.walletVesService.getMyBalance().subscribe({
        next: (res) => {
          this.saldoActual = res.data?.balanceVes || 0;
        },
        error: () => {
          this.saldoActual = 0;
        }
      });
    }
  }

  goToNextStep(): void {
    if (this.isTransitioning || this.currentStep >= this.totalSteps) return;
    this.slideDirection = 'left';
    this.isTransitioning = true;
    setTimeout(() => {
      this.currentStep++;
      this.isTransitioning = false;
    }, 300);
  }

  previousStep(): void {
    if (this.isTransitioning) return;
    if (this.currentStep > 1) {
      this.slideDirection = 'right';
      this.isTransitioning = true;
      setTimeout(() => {
        this.currentStep--;
        this.isTransitioning = false;
      }, 300);
    } else {
      this.router.navigate(['/wallet/home']);
    }
  }

  assignMontoRetiro(amount: number){
    this.montoRetiro = amount;
  }

  assignAccount(account: CuentaBeneficiario){
    this.accountSelected = account;
  }
}
